import { YardPropertiesService } from './../../../../yard-properties.service';
import { Identity } from '@sdbn/common';
import { LeaveRegistration } from './../../dialog/register-leave/model/out/leave-registration';
import { CheckState } from './../../dialog/register-leave/model/CheckState.enum';
import { Check } from './../../dialog/register-leave/model/Check';
import { TranslationService } from '@sdbn/common';
import { RegisterLeaveService } from './../../dialog/register-leave/service/register-leave.service';
import { RegisterLeaveComponent, RegisterLeaveDialogData } from './../../dialog/register-leave/component/register-leave.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { WeighingType } from './../../dialog/register-leave/model/weighing-type.enum';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { TransportOnLeave, DeclineLeaveReason } from './../../dialog/register-leave/model/Transport';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, NgForm, NgModel } from '@angular/forms';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { concat, forkJoin } from 'rxjs';
import { AppClientConfigurationService } from '@sdbn/common';
import { AutoWeighingService } from '../../../../legacy/auto-weighing/auto-weighing.service';
import { AreaGate } from '../../dialog/register-entrance/model/areaGate';
import { SupplementaryEquipmentTakeBackService } from '../../service/supplementary-equipment-take-back.service';
import { SeTakebackTransport, TakeBackSupplementaryEquipment } from '../../model/supplementary-equipment-take-back.model';

export interface RegisterLeaveCombinedDialogData {
  transportId: number;
  callback: () => void;
}

@Component({
    selector: 'app-register-leave-combined',
    templateUrl: './register-leave-combined.component.html',
    styleUrls: ['./register-leave-combined.component.scss'],
    standalone: false
})
export class RegisterLeaveCombinedComponent implements OnInit {

  @ViewChild('weighForm') weighForm: NgForm;

  transport = new TransportOnLeave();
  seTransport = new SeTakebackTransport();
  isLoading = false;

  clientParameters = TMCClientParameters;
  typeOptions: WeighingType[] = [];

  allowExitDespiteOfRuleViolationEnabled = false;
  allowExitDespiteOfRuleViolationFormGroup = new FormGroup({});

  areaGates = new Array<AreaGate>();
  selectedAreaGate: AreaGate = null;

  constructor(
    public dialogRef: MatDialogRef<RegisterLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterLeaveDialogData,
    public configurationService: AppClientConfigurationService,
    private leaveService: RegisterLeaveService,
    private seService: SupplementaryEquipmentTakeBackService,
    public translationService: TranslationService,
    private autoWeighingService: AutoWeighingService,
    public yardPropertiesService: YardPropertiesService) {

    for (const t of Object.keys(WeighingType)) {
      this.typeOptions.push(WeighingType[t]);
    }

    this.allowExitDespiteOfRuleViolationFormGroup.addControl('allowExitDespiteOfRuleViolation', new FormControl(false, []));
    this.allowExitDespiteOfRuleViolationFormGroup.valueChanges.subscribe(
      v => {
        this.transport.allowExitDespiteOfRuleViolation = this.allowExitDespiteOfRuleViolationFormGroup.controls['allowExitDespiteOfRuleViolation'].value;
      }
    );
  }

  ngOnInit() {
    this.isLoading = true;
    const identity = new Identity();
    identity.id = this.data.transportId;

    forkJoin([
        this.seService.getTransport(identity),
        this.leaveService.getTransport(identity),
        this.leaveService.getAreaGates()
      ]).subscribe(results => {
        this.seTransport = results[0];
        this.transport = results[1];
        this.areaGates = results[2];
        if (this.areaGates.length > 0) {
          this.selectedAreaGate = this.areaGates[0];
        }
        this.transport.autoWeightSource = this.yardPropertiesService.getLeaveType();
        this.isLoading = false;
        const defaultType = this.yardPropertiesService.getLeaveScaleKey();
        if (defaultType != null && defaultType.length > 0) {
          this.transport.weighingType = WeighingType[defaultType];
        }
        this.allowExitDespiteOfRuleViolationEnabled = this.transport.declineLeaveCauses?.length > 0 &&
          this.configurationService.isPropertyTrue('outboundcheck.allow-exit-despite-of-rule-violations.enabled', true);
    }, error => {
      console.error(error);
      this.dialogRef.close();
      this.isLoading = false;
    });
  }

  cancelDialog(): void {
    this.dialogRef.close();
  }

  isOk(check: Check) {
    return check.state === CheckState.OK;
  }

  isWarning(check: Check) {
    return check.state === CheckState.WARN;
  }

  isFailed(check: Check) {
    return check.state === CheckState.FAILED;
  }

  checksExist(transport: TransportOnLeave): boolean {
    return transport != null && transport.checks != null && transport.checks.length > 0;
  }

  cancel() {
    this.dialogRef.close();
  }

  decline() {
    this.isLoading = true;

    const lr = new LeaveRegistration();
    lr.transportId = this.transport.id;
    lr.weighingType = this.transport.weighingType;
    lr.weight = this.transport.weight;
    lr.areaGateId = this.selectedAreaGate?.id;

    this.leaveService.decline(lr).subscribe(
      response => {
        this.dialogRef.close();
        this.data.callback();
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  isDeclineDisabled() {
    if (this.isLoading) {
      return true;
    }
    return false;
  }

  selected(se, event: MatCheckboxChange) {
    console.log('se', se, 'selected', event);
    se.selected = event.checked;
    console.log(this.seTransport);
  }

  accept() {
    this.isLoading = true;

    const lr = new LeaveRegistration();
    lr.transportId = this.transport.id;
    lr.weighingType = this.transport.weighingType;
    lr.weight = this.transport.weight;
    lr.autoWeightSource = this.transport.autoWeightSource;
    lr.autoWeight = this.transport.autoWeight;
    lr.allowExitDespiteOfRuleViolation = this.transport.allowExitDespiteOfRuleViolation;
    lr.areaGateId = this.selectedAreaGate?.id;

    concat(
      this.seService.saveTransport(this.seTransport),
      this.leaveService.accept(lr)
    ).subscribe(next => { }, error => {
      console.log('error processing request', error);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
      this.dialogRef.close();
      this.data.callback();
    });
  }

  get isAcceptDisabled() {
    if (this.isLoading) {
      return true;
    }

    for (const se of this.seTransport.supplementaryEquipments) {
      if (!se.selected) {
        return true;
      }
    }

    // es darf nur geprüft werden, wenn das feature aktiv ist!
    if (this.isWeighingActive()) {
      if (this.weighForm && (this.weighForm.invalid || !this.transport.weighingType)) {
        return true;
      }
    }
    if (this.transport.declineLeaveCauses != null) {
      const filteredDeclineLeaveReasons = this.transport.declineLeaveCauses.filter(a => a !== DeclineLeaveReason.HANDOUTED_SUPPLEMENTARY_EQUIPMENT);
      return !this.transport.allowExitDespiteOfRuleViolation && filteredDeclineLeaveReasons.length > 0;
    }
    return false;
  }

  isWeighingTypeRequired(): boolean {
    return this.transport.weight != null && this.transport.weight > 0;

  }

  descriptionExists(check: Check) {
    const description: string = this.translationService.translate(check.descriptionDictionaryKey);
    return typeof description !== 'undefined' && description !== null && description.length > 0;
  }

  showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  supplementaryEquipmendHandouted(seTransport: SeTakebackTransport): boolean {
    return seTransport.supplementaryEquipments != null && seTransport.supplementaryEquipments.length > 0;
  }

  isFormReadonly() {
    return this.isLoading;
  }

  public isWeighingActive(): boolean {
    return this.yardPropertiesService.isWeighingLeaveEnabled() &&
      this.yardPropertiesService.isWeighingEnabled();
  }

  public readWeight() {
    this.autoWeighingService.readWeight(this.transport.autoWeightSource).subscribe(result => {
      this.transport.autoWeight = result.weight;
      this.transport.weight = this.transport.autoWeight;
    });
  }

  public isAutoWeighingVisible(): boolean {
    return this.transport != null && this.transport.autoWeightSource != null && this.transport.autoWeightSource.length > 0;
  }

}
